import { PASSWORD_RULES } from "./passwordRules";
import "./PasswordHint.scss";

type TFn = (key: string) => string;

/** Inline hint HTML (same look as <PasswordHint variant="inline" />) */
export const buildPasswordHintHtml = (
	t: TFn,
	lang = "en",
	id = "passwordHint"
): string => {
	const isZh = lang.startsWith("zh");
	const sep = isZh ? "、" : ", ";
	const [first, ...rest] = PASSWORD_RULES;

	const restHtml = rest
		.map((r, i) => {
			const suffix =
				i < rest.length - 2
					? sep
					: i === rest.length - 2
						? ` ${t("and")} `
						: isZh
							? "。"
							: ".";
			return `<span data-rule="${r.key}">${t(r.inlineLabel)}</span>${suffix}`;
		})
		.join("");

	return `
        <div id="${id}" class="password-hint password-hint--inline" aria-live="polite">
            <i class="fa fa-info-circle me-1"></i>
            <span data-rule="${first.key}">${t(first.inlineLabel)}</span>${isZh ? "，" : ", "}${t("including")} ${restHtml}
        </div>`;
};

/** Live-update the hint as the user types. Returns a cleanup fn. */
export const bindPasswordHint = (
	input: HTMLInputElement,
	hint: HTMLElement
): (() => void) => {
	const update = () => {
		const value = input.value ?? "";
		PASSWORD_RULES.forEach((r) => {
			hint
				.querySelector(`[data-rule="${r.key}"]`)
				?.classList.toggle("rule-passed", r.test(value));
		});
	};
	input.addEventListener("input", update);
	update();
	return () => input.removeEventListener("input", update);
};
